import { memo } from 'react'
import { Theme } from '@mui/material/styles'
import { Typography } from '@mui/material'
import useEmotionStyles from 'hooks/useEmotionStyles'

const styles = (theme: Theme) => ({
  legal: {
    width: '100%',
    marginTop: theme.spacing(2),
    fontSize: theme.typography.pxToRem(12),
    letterSpacing: theme.typography.pxToRem(0.32),
    lineHeight: theme.typography.pxToRem(20)
  }
})

type NoteProps = {
  legalText: string
}

const Note = ({ legalText }: NoteProps) => {
  const { legal } = useEmotionStyles(styles)

  return (
    <Typography className={legal} variant="body2" color={'grey.600'}>
      {legalText}
    </Typography>
  )
}

export default memo(Note)
